import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Layout } from 'antd'
import './override.scss'
import './styles.scss'
import routes from 'Utils/mainRoutes'
import Header from './Header'
import Footer from './Footer'
const { Content } = Layout

class CoreLayoutContainer extends React.Component {
  render () {
    return (
      <Layout className='layout-container'>
        <Header />
        <Content className='base-content'>
          <Switch>
            {routes.map((route, idx) => {
                return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                    <route.component {...props} />
                  )} />)
                  : (null);
              },
            )}
          </Switch>
        </Content>
        <Footer />
      </Layout>
    )
  }
}

export default CoreLayoutContainer